import type { TourDefinition } from '../tours.types';

export const MODAL_AGREGAR_CERTIFICADO_SELECCION_TOUR: TourDefinition = {
  id: 'modal_agregar_certificado_seleccion_help',
  remember: true,
  steps: [
    {
      element: '[data-tour="tabla-certificados"]',
      popover: {
        title: 'Certificados disponibles',
        description:
          'Aquí se muestran los certificados asociados al usuario. Deberás seleccionar únicamente uno, que será el certificado con el cual el usuario realizará la firma.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tabla-certificado-seleccionar"]',
      popover: {
        title: 'Seleccionar certificado',
        description:
          'Haz clic sobre el certificado que deseas utilizar. Al seleccionarlo, se agregará automáticamente a la vista principal como participante del proceso de firma.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
};
